import React from "react";
import { Redirect } from "react-router-dom";
import { Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

// lazy load all the views

/*
Please keep the order like in the menu
Please keep order and naming theme like: Orders, OrderDetails, OrderForm
First letter is always capitalised
*/

// Main Menu
// Dashboard
const Dashboard = React.lazy(() => import("../pages/dashboard"));
const CompleteOverview = React.lazy(
  () => import("../pages/completeOverview/CompleteOverview"),
);
// Orders
const Orders = React.lazy(() => import("../pages/orders/Orders"));
const OrderDetails = React.lazy(() => import("../pages/orders/OrderDetails"));
/* const OrderForm = React.lazy(() => import("../pages/orders/OrderForm")); */
// Deliveries
const Delivery = React.lazy(() => import("../pages/deliveries/Delivery"));
const DeliveryDetails = React.lazy(
  () => import("../pages/deliveries/DeliveryDetails"),
);
const DeliveryForm = React.lazy(
  () => import("../pages/deliveries/DeliveryForm"),
);
const FreightRatesForm = React.lazy(
  () => import("../pages/deliveries/FreightRatesForm"),
);
// Shipments
const Shipments = React.lazy(() => import("../pages/shipments/Shipments"));
const ShipmentDetails = React.lazy(
  () => import("../pages/shipments/ShipmentDetails"),
);
const ShipmentForm = React.lazy(
  () => import("../pages/shipments/ShipmentForm"),
);
const SeaFreightRatesForm = React.lazy(
  () => import("../pages/shipments/FreightRatesForm"),
);
const Customs = React.lazy(() => import("../pages/customs/Customs"));
const CustomsDetails = React.lazy(
  () => import("../pages/customs/CustomsDetails"),
);
const CustomsForm = React.lazy(() => import("../pages/customs/CustomsForm"));

// Air Freights
const AirFreights = React.lazy(
  () => import("../pages/airFreights/AirFreights"),
);
const AirFreightDetails = React.lazy(
  () => import("../pages/airFreights/AirFreightDetails"),
);
const AirFreightForm = React.lazy(
  () => import("../pages/airFreights/AirFreightForm"),
);

// Purchase Orders
const PurchaseOrders = React.lazy(
  () => import("../pages/purchaseOrders/PurchaseOrders"),
);
const PurchaseOrderDetails = React.lazy(
  () => import("../pages/purchaseOrders/PurchaseOrderDetails"),
);
const PurchaseOrderQualityReportForm = React.lazy(
  () => import("../pages/purchaseOrders/PurchaseOrderQualityReportForm"),
);

// Payments
const Payments = React.lazy(() => import("../pages/payments/Payments"));
const PaymentDetails = React.lazy(
  () => import("../pages/payments/PaymentDetails"),
);
const PaymentForm = React.lazy(() => import("../pages/payments/PaymentForm"));

// Product Requests
const ProductRequests = React.lazy(
  () => import("../pages/productRequests/ProductRequests"),
);
const ProductRequestDetails = React.lazy(
  () => import("../pages/productRequests/ProductRequestDetails"),
);
const ProductRequestForm = React.lazy(
  () => import("../pages/productRequests/ProductRequestForm"),
);
const ProductRequestCalculation = React.lazy(
  () => import("../pages/productRequests/ProductRequestCalculation"),
);
const CustomerRequests = React.lazy(
  () => import("../pages/customerRequests/CustomerRequests"),
);

const CustomerRequestForms = React.lazy(
  () => import("../pages/customerRequests/CustomerRequestForm"),
);
const SalesOffers = React.lazy(
  () => import("../pages/salesOffers/SalesOffers"),
);

const SalesOfferDetails = React.lazy(
  () => import("../pages/salesOffers/SalesOffersDetails"),
);

// Public (no login): customer opens the offer from the mailed link (#2377).
const PublicOffer = React.lazy(
  () => import("../pages/salesOffers/PublicOffer"),
);
const PublicOfferAccepted = React.lazy(
  () => import("../pages/salesOffers/PublicOfferAccepted"),
);

const SalesOfferForm = React.lazy(
  () => import("../pages/salesOffers/SalesOffersForm"),
);

const Notifications = React.lazy(
  () => import("../pages/notifications/Notifications"),
);

// CRM-Tasks (eigenes Tasks-Model, siehe .claude/docs/features/crm-migration.md 1.4)
const Tasks = React.lazy(() => import("../pages/tasks/Tasks"));
// CRM-Kontaktebene (R2) — Standardsicht bleibt die Firmenebene
const Contacts = React.lazy(() => import("../pages/contacts/Contacts"));
// Verlauf eines Kontakts ohne Firma — Uebergangsseite, siehe ContactActivity.js
const ContactActivity = React.lazy(
  () => import("../pages/contacts/ContactActivity"),
);

// Items
const Items = React.lazy(() => import("../pages/items/Items"));
const ItemDetails = React.lazy(() => import("../pages/items/ItemDetails"));
const ItemForm = React.lazy(() => import("../pages/items/ItemForm"));
const ItemsHeadForm = React.lazy(() => import("../pages/items/ItemsHeadForm"));
const ItemQualityReportTemplateForm = React.lazy(
  () => import("../pages/items/ItemQualityReportTemplateForm"),
);
//Customers
const Customers = React.lazy(() => import("../pages/customers/Customers"));
const CallLookup = React.lazy(() => import("../pages/customers/CallLookup"));
const MailLookup = React.lazy(() => import("../pages/customers/MailLookup"));
const CustomerDetails = React.lazy(
  () => import("../pages/customers/CustomerDetails"),
);
//Suppliers
const Suppliers = React.lazy(() => import("../pages/suppliers/Suppliers"));
const SupplierDetails = React.lazy(
  () => import("../pages/suppliers/SupplierDetails"),
);
//Forwarders
const Forwarders = React.lazy(() => import("../pages/forwarders/Forwarders"));
const ForwarderDetails = React.lazy(
  () => import("../pages/forwarders/ForwarderDetails"),
);
const InvoiceDetails = React.lazy(
  () => import("../pages/invoices/InvoiceDetails"),
);
const ForwarderForm = React.lazy(
  () => import("../pages/forwarders/ForwarderForm"),
);
// Measuring Instruments
const MeasuringInstruments = React.lazy(
  () => import("../pages/measuringInstruments/MeasuringInstruments"),
);
const MeasuringInstrumentForm = React.lazy(
  () => import("../pages/measuringInstruments/MeasuringInstrumentForm"),
);
const CustomerForm = React.lazy(
  () => import("../pages/customers/CustomerForm"),
);
const CustomerMerge = React.lazy(
  () => import("../pages/customers/CustomerMerge"),
);
const SuppliersForm = React.lazy(
  () => import("../pages/suppliers/SupplierForm"),
);
const SupplierMerge = React.lazy(
  () => import("../pages/suppliers/SupplierMerge"),
);

// Supplier Purchase Orders
const SupplierPurchaseOrders = React.lazy(
  () => import("../pages/supplierPurchaseOrders/SupplierPurchaseOrders"),
);
const SupplierPurchaseOrderDetails = React.lazy(
  () => import("../pages/supplierPurchaseOrders/SupplierPurchaseOrderDetails"),
);

// Supplier Requests
const SupplierRequests = React.lazy(
  () => import("../pages/supplierRequests/SupplierRequests"),
);
const SupplierRequestForm = React.lazy(
  () => import("../pages/supplierRequests/SupplierRequestForm"),
);
const Claims = React.lazy(() => import("../pages/claims/Claims"));
const ClaimForm = React.lazy(() => import("../pages/claims/ClaimForm"));

// Quality Reports
const QualityReports = React.lazy(
  () => import("../pages/qualityReports/QualityReports"),
);
// Load Calculator
const LoadCalculator = React.lazy(
  () => import("../pages/loadCalculator/LoadCalculator"),
);
const LoadCalculatorHistory = React.lazy(
  () => import("../pages/loadCalculator/LoadCalculatorHistory"),
);

// Dropdown Menu
const Contact = React.lazy(() => import("../pages/contact/Contact"));
const Profile = React.lazy(() => import("../pages/profile/Profile"));
const UserManagement = React.lazy(
  () => import("../pages/userManagement/UserManagement"),
);
const UserRolesManagement = React.lazy(
  () => import("../pages/userRolesManagement/UserRolesManagement"),
);
const ImportValues = React.lazy(
  () => import("../pages/importValues/ImportValues"),
);
const PrivacyMode = React.lazy(
  () => import("../pages/privacyMode/PrivacyMode"),
);
// auth
const Login = React.lazy(() => import("../pages/account/Login"));
const Logout = React.lazy(() => import("../pages/account/Logout"));
const Register = React.lazy(() => import("../pages/account/Register"));
const InvitationRegister = React.lazy(
  () => import("../pages/account/InvitationRegister"),
);
const Confirm = React.lazy(() => import("../pages/account/Confirm"));
const ForgetPassword = React.lazy(
  () => import("../pages/account/ForgetPassword"),
);
const SetNewPassword = React.lazy(
  () => import("../pages/account/SetNewPassword"),
);
const VerifyEmail = React.lazy(() => import("../pages/account/VerifyEmail"));
// pages
const ErrorPageNotFound = React.lazy(
  () => import("../pages/error/PageNotFound"),
);
const ForbiddenErrorPage = React.lazy(
  () => import("../pages/error/ForbiddenErrorPage"),
);

// Initial Setup
const InitialSetup = React.lazy(
  () => import("../pages/initialSetup/InitialSetup"),
);

/*
Please keep the order like in the menu
Please keep order and naming theme like:  orders, orderDetails, orderCreate, orderEdit 
First letter is always lower case
*/

// root routes
const rootRoute = {
  path: "/",
  exact: true,
  component: () => <Redirect to="/dashboard" />,
  route: PrivateRoute,
};
// Mainmenu Objects
const dashboard = {
  path: "/dashboard",
  name: "Analytics",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Dashboard,
  header: "Line Up - Dashboard",
};
const notifications = {
  path: "/notifications/",
  name: "Notifications",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Notifications,
  header: "Line Up - Notifications",
};
const tasks = {
  path: "/tasks",
  name: "Tasks",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Tasks,
  header: "Line Up - Tasks",
};
const contacts = {
  // `exact`, damit /contacts/:contactId darunter nicht von der Liste geschluckt
  // wird — im <Switch> gewinnt der erste Treffer.
  path: "/contacts",
  exact: true,
  name: "Contacts",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Contacts,
  header: "Line Up - Contacts",
};
// Nur fuer Kontakte OHNE Firma. Mit Firma leitet die Seite auf die Firmenakte um.
const contactActivity = {
  path: "/contacts/:contactId",
  exact: true,
  name: "Contact Activity",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ContactActivity,
  header: "Line Up - Contact Activity",
};
const completeOverview = {
  path: "/completeOverview",
  name: "CompleteOverview",
  route: PrivateRoute,
  icon: "uil-calender",
  component: CompleteOverview,
  header: "Line Up - CompleteOverview",
};
const orders = {
  path: "/orders",
  exact: true,
  name: "Orders",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Orders,
  header: "Orders",
};
const orderDetails = {
  path: "/order/:orderID",
  exact: true,
  name: "Order Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: OrderDetails,
  header: "Line Up - Order Details",
};
/* const orderEdit = {
  path: "/order/edit/:orderID",
  name: "Order Edit",
  route: PrivateRoute,
  icon: "uil-calender",
  component: OrderForm,
  header: "Line Up - Order Edit",
}; */
const goodsReceipt = {
  path: "/goodsReceipts",
  exact: true,
  name: "Goods Receipts",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Delivery,
  header: "Line Up - Goods Receipts",
};
const goodsReceiptDetails = {
  path: "/goodsReceipt/:deliveryId",
  name: "Goods Receipt Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: DeliveryDetails,
  header: "Line Up - Goods Receipt",
};

const goodsIssue = {
  path: "/goodsIssues",
  exact: true,
  name: "Goods Issue",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Delivery,
  header: "Line Up - Goods Issue",
};
const goodsIssueDetails = {
  path: "/goodsIssue/:deliveryId",
  name: "Delivery Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: DeliveryDetails,
  header: "Line Up - Goods Issue Details",
};
const goodsIssueCreate = {
  path: "/goodsIssueForm/create",
  name: "Create Delivery",
  route: PrivateRoute,
  icon: "uil-calender",
  component: DeliveryForm,
  header: "Line Up - Create Goods Issue",
};
const goodsIssueEdit = {
  path: "/goodsIssueForm/edit/:deliveryId",
  name: "Edit Delivery",
  route: PrivateRoute,
  icon: "uil-calender",
  component: DeliveryForm,
  header: "Line Up - Edit Goods Issue",
};

const directDelivery = {
  path: "/directDeliveries",
  exact: true,
  name: "Direct Deliveries",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Delivery,
  header: "Line Up - Direct Deliveries",
};
const directDeliveryDetails = {
  path: "/directDelivery/:deliveryId",
  name: "Direct Delivery Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: DeliveryDetails,
  header: "Line Up - Direct Delivery Details",
};

const delivery = {
  path: "/deliveries",
  exact: true,
  name: "Delivery",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Delivery,
  header: "Line Up - Delivery",
};
const deliveryDetails = {
  path: "/delivery/:deliveryId",
  name: "Delivery Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: DeliveryDetails,
  header: "Line Up - Delivery Details",
};
const salesOffers = {
  path: "/offers",
  exact: true,
  name: "Offers",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SalesOffers,
  header: "Offers",
};
const salesOffersDetails = {
  path: "/offer/:offerID",
  exact: true,
  name: "Offer Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SalesOfferDetails,
  header: "Line Up - Offfer Details",
};
const salesOffersEdit = {
  path: "/offer/edit/:offerID",
  name: "Offer Edit",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SalesOfferForm,
  header: "Line Up - Offer Edit",
};
const customerRequests = {
  path: "/requests",
  name: "Requests",
  route: PrivateRoute,
  icon: "uil-calender",
  component: CustomerRequests,
  header: "Line Up - Requests",
};
const customerRequestCreate = {
  path: "/request/create",
  name: "Request Create",
  route: PrivateRoute,
  icon: "uil-calender",
  component: CustomerRequestForms,
  header: "Line Up - Request Create",
};
const customerRequestEdit = {
  path: "/request/edit/:customerRequestID",
  name: "Request Edit ",
  route: PrivateRoute,
  icon: "uil-calender",
  component: CustomerRequestForms,
  header: "Line Up - Request Edit",
};
const supplierPurchaseOrders = {
  path: "/supplierPurchaseOrders",
  name: "Supplier Purchase Orders",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SupplierPurchaseOrders,
  header: "Line Up - Supplier Purchase Orders",
};
const supplierPurchaseOrderDetails = {
  path: "/supplierPurchaseOrder/:supplierPurchaseOrderId",
  name: "Supplier Purchase Order Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SupplierPurchaseOrderDetails,
  header: "Line Up - Supplier Purchase Order Details",
};
const supplierRequests = {
  path: "/supplierRequests",
  name: "Supplier Requests",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SupplierRequests,
  header: "Line Up - Supplier Requests",
};
const supplierRequestsEdit = {
  path: "/supplierRequest/edit/:supplierRequestID",
  name: "Supplier Requests Edit ",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SupplierRequestForm,
  header: "Line Up - Supplier Requests Edit",
};
const claims = {
  path: "/claims",
  exact: true,
  name: "Claims",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Claims,
  header: "Line Up - Claims",
};
const claimEdit = {
  path: "/claim/edit/:claimId",
  exact: true,
  name: "Claim Edit",
  route: PrivateRoute,
  component: ClaimForm,
  header: "Line Up - Claim Edit",
};
const claimCreate = {
  path: "/claim/new",
  exact: true,
  name: "Claim Create",
  route: PrivateRoute,
  component: ClaimForm,
  header: "Line Up - Claim Create",
};
const freightRatesForm = {
  path: "/freightRates/create",
  name: "Freight Rates Create",
  route: PrivateRoute,
  icon: "uil-calender",
  component: FreightRatesForm,
  header: "Line Up - Freight Rates Create",
};
const shipments = {
  path: "/shipments",
  exact: true,
  name: "Shipments",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Shipments,
  header: "Line Up - Shipments",
};
const shipmentDetails = {
  path: "/shipment/:shipmentID",
  exact: true,
  name: "Shipment Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ShipmentDetails,
  header: "Line Up - Shipment Details",
};
const shipmentCreate = {
  path: "/shipments/create",
  name: "Shipment Create",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ShipmentForm,
  header: "Line Up - Shipment Create",
};
const shipmentEdit = {
  path: "/shipment/edit/:shipmentId",
  name: "Shipment Edit",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ShipmentForm,
  header: "Line Up - Shipment Edit",
};
const seaFreightRatesForm = {
  path: "/seaFreightRates/create",
  name: "Freight Rates Create",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SeaFreightRatesForm,
  header: "Line Up - Freight Rates Create",
};
const customs = {
  path: "/customs",
  exact: true,
  name: "Customs",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Customs,
  header: "Line Up - Customs",
};
const customsDetails = {
  path: "/customs/:customsID",
  exact: true,
  name: "Customs Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: CustomsDetails,
  header: "Line Up - Customs Details",
};
const customsCreate = {
  path: "/custom/create",
  name: "Customs Create",
  exact: true,
  route: PrivateRoute,
  icon: "uil-calender",
  component: CustomsForm,
  header: "Line Up - Customs Create",
};
const customsEdit = {
  path: "/custom/edit/:customsID",
  name: "Customs Edit",
  exact: true,
  route: PrivateRoute,
  icon: "uil-calender",
  component: CustomsForm,
  header: "Line Up - Customs Edit",
};
const airFreights = {
  path: "/airFreights",
  exact: true,
  name: "Air Freights",
  route: PrivateRoute,
  icon: "uil-calender",
  component: AirFreights,
  header: "Line Up - Air Freights",
};

const airFreightDetails = {
  path: "/airFreight/:airFreightID",
  exact: true,
  name: "Air Freight Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: AirFreightDetails,
  header: "Line Up - Air Freight Details",
};

const airFreightCreate = {
  path: "/airFreights/create",
  name: "Air Freights",
  route: PrivateRoute,
  icon: "uil-calender",
  component: AirFreightForm,
  header: "Line Up - Air Freight Create",
};

const airFreightEdit = {
  path: "/airFreight/edit/:airFreightID",
  name: "Air Freights",
  route: PrivateRoute,
  icon: "uil-calender",
  component: AirFreightForm,
  header: "Line Up - Air Freight Edit",
};
const purchaseOrders = {
  path: "/purchaseOrders",
  exact: true,
  name: "Purchase Orders",
  route: PrivateRoute,
  icon: "uil-calender",
  component: PurchaseOrders,
  header: "Line Up - Purchase Orders",
};
const purchaseOrderDetails = {
  path: "/purchaseOrder/:purchaseOrderId",
  exact: true,
  name: "Purchase Order Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: PurchaseOrderDetails,
  header: "Line Up - Purchase Order Details",
};
const purchaseOrderQualityReportEdit = {
  path: "/edit/qualityReport/:qualityReportId",
  exact: true,
  name: "Purchase Order Edit Quality Report",
  route: PrivateRoute,
  icon: "uil-calender",
  component: PurchaseOrderQualityReportForm,
  header: "Line Up - Purchase Order Edit Quality Report",
};
const payments = {
  path: "/payments",
  exact: true,
  name: "Payments",
  route: PrivateRoute,
  icon: "uil-money-bill",
  component: Payments,
  header: "Line Up - Payments",
};
const paymentDetails = {
  path: "/payment/:paymentId",
  exact: true,
  name: "Payment Details",
  route: PrivateRoute,
  icon: "uil-money-bill",
  component: PaymentDetails,
  header: "Line Up - Payment Details",
};
const paymentCreate = {
  path: "/payment/new",
  exact: true,
  name: "Payment Create",
  route: PrivateRoute,
  icon: "uil-money-bill",
  component: PaymentForm,
  header: "Line Up - New Payment",
};
const paymentEdit = {
  path: "/payment/edit/:paymentId",
  exact: true,
  name: "Payment Edit",
  route: PrivateRoute,
  icon: "uil-money-bill",
  component: PaymentForm,
  header: "Line Up - Edit Payment",
};
const productRequests = {
  path: "/productRequests",
  exact: true,
  name: "Product Requests",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ProductRequests,
  header: "Line Up - Product Requests",
};
const productRequestDetails = {
  path: "/productRequest/:productRequestId",
  exact: true,
  name: "Product Request Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ProductRequestDetails,
  header: "Line Up - Product Request Details",
};
const productRequestCreate = {
  path: "/productRequests/create",
  name: "Create Product Request",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ProductRequestForm,
  header: "Line Up - Create Product Request",
};
const productRequestEdit = {
  path: "/productRequest/edit/:productRequestId",
  name: "Product Request Edit",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ProductRequestForm,
  header: "Line Up - Product Request Edit",
};
const productRequestCalculation = {
  path: "/productRequestCalculation/:productRequestItemId",
  name: "Product Request Calculation",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ProductRequestCalculation,
  header: "Line Up - Product Request Calculation",
};
const items = {
  path: "/items",
  exact: true,
  name: "Items",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Items,
  header: "Line Up - Items",
};
const itemDetails = {
  path: "/item/:itemId",
  exact: true,
  name: "Item Details",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ItemDetails,
  header: "Line Up - Item Details",
};
const itemCreate = {
  path: "/items/create",
  exact: true,
  name: "Item Create",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ItemForm,
  header: "Line Up - Item Create",
};
const itemsHeadCreate = {
  path: "/items/head/create",
  exact: true,
  name: "Items Head Create",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ItemsHeadForm,
  header: "Line Up - Items Head Create",
};
const itemsHeadEdit = {
  path: "/items/head/edit/:itemsHeadID",
  exact: true,
  name: "Items Head Edit",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ItemsHeadForm,
  header: "Line Up - Items Head Edit",
};
const itemEdit = {
  path: "/item/edit/:itemID",
  exact: true,
  name: "Item Edit",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ItemForm,
  header: "Line Up - Item Edit",
};
const itemsMultiEdit = {
  path: "/itemMultiedit",
  exact: true,
  name: "Item Edit",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ItemForm,
  header: "Line Up - Items Multi Edit",
};

const itemEditQualityReportTemplate = {
  path: "/item/edit/qualityReportTemplate/:templateId",
  exact: true,
  name: "Item Edit Quality Report Template",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ItemQualityReportTemplateForm,
  header: "Line Up - Item Edit Quality Report Template",
};
const qualityReports = {
  path: "/qualityReports",
  exact: true,
  name: "Quality Reports",
  route: PrivateRoute,
  icon: "uil-calender",
  component: QualityReports,
  header: "Line Up - Quality Reports",
};
const customers = {
  path: "/customers",
  name: "Users Edit Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Customers,
  header: "Line Up - Customers Overview Page",
};
const suppliers = {
  path: "/suppliers",
  name: "Users Edit Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Suppliers,
  header: "Line Up - Suppliers Overview Page",
};

const customerDetails = {
  path: "/customer/:companyId",
  name: "Customer Edit Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: CustomerDetails,
  header: "Line Up - Customers Details Page",
};
// Leads open on the customer page; older notifications still link to /lead/:id (#4360).
const leadDetails = {
  path: "/lead/:companyId",
  name: "Lead Redirect",
  route: PrivateRoute,
  component: ({ match, location }) => (
    <Redirect to={`/customer/${match.params.companyId}${location.search}`} />
  ),
};
// Ziel des AGFEO-Klick-Knopfes im Anrufer-PopUp: loest die Rufnummer auf und
// leitet auf die Firma bzw. den Kontakt weiter.
const callLookup = {
  path: "/call/:number",
  name: "Incoming Call Lookup",
  route: PrivateRoute,
  icon: "uil-phone",
  component: CallLookup,
  header: "Line Up - Incoming Call",
};
// Ziel des Outlook-Add-ins (public/outlook/): loest die Adressen einer Mail auf und
// leitet auf die Firma bzw. den Kontakt weiter. Adressen als ?emails=, nicht im Pfad:
// der Dev-Server haelt Pfade mit Punkt fuer Dateien.
const mailLookup = {
  path: "/mail-lookup",
  name: "Email Lookup",
  route: PrivateRoute,
  icon: "uil-envelope",
  component: MailLookup,
  header: "Line Up - Email Lookup",
};

const companySettings = {
  path: "/companySettings/:companyId",
  name: "Customer Edit Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: CustomerDetails,
  header: "Line Up - Customers Details Page",
};

const supplierDetails = {
  path: "/supplier/:companyId",
  name: "Supplier Edit Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SupplierDetails,
  header: "Line Up - Suppliers Details Page",
};

const supplierSettings = {
  path: "/supplierSettings/:companyId",
  name: "Supplier Settings Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SupplierDetails,
  header: "Line Up - Suppliers Settings Page",
};

const supplierCreate = {
  path: "/supplier/create",
  exact: true,
  name: "Supplier Create Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SuppliersForm,
  header: "Line Up - Suppliers Create Page",
};

const customerCreate = {
  path: "/customer/create",
  exact: true,
  name: "Customer Create Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: CustomerForm,
  header: "Line Up - Customers Create Page",
};

const customerEdit = {
  path: "/customer/edit/:companyId",
  exact: true,
  name: "Customer Create Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: CustomerForm,
  header: "Line Up - Customers Create Page",
};
const customerMerge = {
  path: "/customer/merge",
  name: "Customer Merge",
  route: PrivateRoute,
  roles: ["Admin", "superadmin"],
  icon: "uil-calender",
  component: CustomerMerge,
  header: "Line Up - Merge Customer",
};

const supplierMerge = {
  path: "/supplier/merge",
  name: "Supplier Merge",
  route: PrivateRoute,
  roles: ["Admin", "superadmin"],
  icon: "uil-calender",
  component: SupplierMerge,
  header: "Line Up - Merge Supplier",
};

const supplierEdit = {
  path: "/supplier/edit/:companyId",
  exact: true,
  name: "Customer Create Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: SuppliersForm,
  header: "Line Up - Suppliers Create Page",
};

const forwarders = {
  path: "/forwarders",
  name: "Forwarders Overview Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Forwarders,
  header: "Line Up - Forwarders Overview Page",
};

const invoiceDetails = {
  path: "/invoices/:id",
  name: "Invoice Details Page",
  route: PrivateRoute,
  icon: "uil-bill",
  component: InvoiceDetails,
  header: "Line Up - Invoice Details Page",
};

const forwarderDetails = {
  path: "/forwarder/:companyId",
  name: "Forwarder Details Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ForwarderDetails,
  header: "Line Up - Forwarder Details Page",
};

const forwarderCreate = {
  path: "/forwarder/create",
  exact: true,
  name: "Forwarder Create Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ForwarderForm,
  header: "Line Up - Forwarder Create Page",
};

const forwarderEdit = {
  path: "/forwarder/edit/:companyId",
  exact: true,
  name: "Forwarder Edit Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ForwarderForm,
  header: "Line Up - Forwarder Edit Page",
};

const measuringInstruments = {
  path: "/measuringInstruments",
  exact: true,
  name: "Measuring Instruments Overview Page",
  route: PrivateRoute,
  icon: "mdi mdi-tape-measure",
  component: MeasuringInstruments,
  header: "Line Up - Measuring Instruments Overview Page",
};

const measuringInstrumentCreate = {
  path: "/measuringInstrument/create",
  exact: true,
  name: "Measuring Instrument Create Page",
  route: PrivateRoute,
  icon: "mdi mdi-tape-measure",
  component: MeasuringInstrumentForm,
  header: "Line Up - Measuring Instrument Create Page",
};

const measuringInstrumentEdit = {
  path: "/measuringInstrument/edit/:instrumentId",
  exact: true,
  name: "Measuring Instrument Edit Page",
  route: PrivateRoute,
  icon: "mdi mdi-tape-measure",
  component: MeasuringInstrumentForm,
  header: "Line Up - Measuring Instrument Edit Page",
};

// Load Calculator
const loadCalculatorHistory = {
  path: "/loadCalculator/history",
  exact: true,
  name: "Load Calculator History",
  route: PrivateRoute,
  icon: "mdi mdi-history",
  component: LoadCalculatorHistory,
  header: "Line Up - Calculation History",
};
const loadCalculator = {
  path: "/loadCalculator",
  exact: true,
  name: "Load Calculator",
  route: PrivateRoute,
  icon: "mdi mdi-truck-delivery-outline",
  component: LoadCalculator,
  header: "Line Up - Load Calculator",
};

// Dropdown Menu Objects
const contact = {
  path: "/contact",
  name: "Contact",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Contact,
  header: "Line Up - Contact",
};
const profile = {
  path: "/account",
  name: "Account",
  route: PrivateRoute,
  icon: "uil-calender",
  component: Profile,
  header: "Line Up - Account",
};
const userManagement = {
  path: "/users-management",
  name: "Users",
  route: PrivateRoute,
  icon: "uil-calender",
  component: UserManagement,
  header: "Line Up - Users",
};
const userRolesManagement = {
  path: "/userRolesManagement",
  exact: true,
  name: "UserRolesManagement",
  route: PrivateRoute,
  icon: "uil-calender",
  component: UserRolesManagement,
  header: "User Roles Management",
};
const importValues = {
  path: "/importValues",
  name: "ImportValues",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ImportValues,
  header: "User Roles Management",
};
// Personal setting, so deliberately not permission-gated — every user configures their own.
const privacyMode = {
  path: "/privacyMode",
  exact: true,
  name: "PrivacyMode",
  route: PrivateRoute,
  icon: "uil-calender",
  component: PrivacyMode,
  header: "Line Up - Privacy Mode",
};
// others
const forbiddenPageLineUp = {
  path: "/error-permission-denied",
  name: "Forbidden Error Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ForbiddenErrorPage,
  header: "Line Up - Forbidden Error Page",
};
const errorPageLineUp = {
  path: "*",
  name: "Error Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: ErrorPageNotFound,
  header: "Line Up - Error Page",
};

// Initial Setup
const initialSetup = {
  path: "/initial-setup",
  name: "Initial Setup Page",
  route: PrivateRoute,
  icon: "uil-calender",
  component: InitialSetup,
  header: "Line Up - Dashboard",
};

const appRoutes = [
  // initialSetup,
  // Main Menu
  dashboard,
  notifications,
  tasks,
  completeOverview,
  orders,
  orderDetails,
  /*   orderEdit, */
  customerRequests,
  customerRequestCreate,
  customerRequestEdit,
  delivery,
  deliveryDetails,
  goodsReceipt,
  goodsReceiptDetails,
  goodsIssue,
  goodsIssueDetails,
  goodsIssueCreate,
  goodsIssueEdit,
  directDelivery,
  directDeliveryDetails,
  freightRatesForm,
  shipments,
  shipmentDetails,
  shipmentCreate,
  shipmentEdit,
  seaFreightRatesForm,
  customs,
  customsDetails,
  customsCreate,
  customsEdit,
  salesOffers,
  salesOffersDetails,
  salesOffersEdit,
  purchaseOrders,
  purchaseOrderDetails,
  purchaseOrderQualityReportEdit,
  paymentCreate,
  paymentEdit,
  payments,
  paymentDetails,
  airFreights,
  airFreightDetails,
  airFreightCreate,
  airFreightEdit,
  productRequests,
  productRequestDetails,
  productRequestCreate,
  productRequestEdit,
  productRequestCalculation,
  items,
  itemDetails,
  itemCreate,
  itemEdit,
  itemsMultiEdit,
  itemsHeadCreate,
  itemsHeadEdit,
  itemEditQualityReportTemplate,
  qualityReports,
  suppliers,
  customers,
  callLookup,
  mailLookup,
  supplierCreate,
  customerCreate,
  supplierMerge,
  customerMerge,
  supplierEdit,
  customerEdit,
  customerDetails,
  leadDetails,
  contacts,
  contactActivity,
  supplierDetails,
  supplierPurchaseOrders,
  supplierPurchaseOrderDetails,
  invoiceDetails,
  forwarders,
  forwarderCreate,
  forwarderEdit,
  forwarderDetails,
  measuringInstruments,
  measuringInstrumentCreate,
  measuringInstrumentEdit,
  supplierRequests,
  supplierRequestsEdit,
  claims,
  claimEdit,
  claimCreate,
  // Load Calculator
  loadCalculatorHistory,
  loadCalculator,
  // Dropdown Menu
  contact,
  profile,
  companySettings,
  supplierSettings,
  userRolesManagement,
  importValues,
  userManagement,
  privacyMode,
  // others
  forbiddenPageLineUp,
  errorPageLineUp, // this one always has to be the last
];

// pages

const otherPublicRoutes = [
  {
    path: "/error-404",
    name: "Error - 404",
    component: ErrorPageNotFound,
    route: Route,
  },
  {
    // Success page after accepting via the public link (thanks + register).
    // Listed before /offer/public/:token so "accepted" is never read as a token.
    path: "/offer/accepted",
    name: "Public Offer Accepted",
    component: PublicOfferAccepted,
    exact: true,
    route: Route,
  },
  {
    // Customer accepts/declines a sales offer via personal email link, no
    // Cognito session. Public routes are matched before the authenticated
    // tree, so /offer/:offerID never captures this. App.js excludes the path
    // from the logout redirect.
    path: "/offer/public/:token",
    name: "Public Offer",
    component: PublicOffer,
    exact: true,
    route: Route,
  },
];

// flatten the list of all nested routes
const flattenRoutes = (routes) => {
  let flatRoutes = [];

  routes = routes || [];
  routes.forEach((item) => {
    flatRoutes.push(item);

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// auth
const authRoutes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    route: Route,
  },
  {
    path: "/initial-setup",
    name: "Initial Setup",
    component: InitialSetup,
    exact: true,
    route: Route,
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
    route: Route,
  },
  {
    path: "/register/:type",
    exact: true,
    name: "Register",
    component: Register,
    route: Route,
  },
  // This including the inviationID has been manually added by MAX:
  {
    path: "/register/:invitationID",
    name: "InvitationRegister",
    component: InvitationRegister,
    route: Route,
  },
  {
    path: "/confirm",
    name: "Confirm",
    component: Confirm,
    route: Route,
  },
  {
    path: "/forget-password",
    name: "Forget Password",
    component: ForgetPassword,
    route: Route,
  },
  {
    path: "/new-password",
    name: "New Password",
    component: SetNewPassword,
    route: Route,
  },
  {
    path: "/verify-email",
    name: "Verify Email",
    component: VerifyEmail,
    route: Route,
  },
];

// All routes
const authProtectedRoutes = [rootRoute, ...appRoutes, initialSetup];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);

export {
  publicRoutes,
  authProtectedRoutes,
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
};
